import React from 'react'
import { Table } from 'semantic-ui-react'
import { BatchAliasAssignment } from '../../../redux/types/productAliases'
import { BatchLookupValue } from '../../../redux/types/ui'
import { BatchStatusIcon } from './BatchStatusIcon'

export type AssignmentStatus = 'ignored' | 'confirmed' | 'selected' | null

const batchAliasAssignmentStatus = (
  aliasAssignment?: Pick<BatchAliasAssignment, 'isIgnored' | 'isConfirmed' | 'batchSelectedProduct'>
): AssignmentStatus => {
  const { isIgnored, isConfirmed, batchSelectedProduct } = aliasAssignment || {}
  if (isIgnored) return 'ignored'
  if (isConfirmed) return 'confirmed'
  if (batchSelectedProduct) return 'selected'
  return null
}

interface Props {
  batchLookupValue: BatchLookupValue
  batchAliasAssignment?: BatchAliasAssignment
  index: number
  hadError?: boolean
  isActive?: boolean
  updateSelectedItem: () => void
}

export const BatchLookupListItem = ({
  batchLookupValue,
  batchAliasAssignment,
  index,
  hadError,
  isActive,
  updateSelectedItem,
}: Props) => {
  const status = batchAliasAssignmentStatus(batchAliasAssignment)

  return (
    <Table.Row
      id={`item-${index}`}
      style={{ cursor: 'pointer' }}
      negative={hadError}
      active={isActive}
    >
      <Table.Cell className="icon-cell" positive={status === 'confirmed'}>
        <BatchStatusIcon status={status} />
      </Table.Cell>
      <Table.Cell
        className="name-cell"
        positive={status === 'confirmed'}
        onClick={() => {
          if (!hadError) {
            updateSelectedItem()
          }
        }}
      >
        {batchLookupValue.name}
      </Table.Cell>
    </Table.Row>
  )
}
